module.exports = __webpack_public_path__ + "img/img-chuanyuan-s4.15c38315.jpg";